import { createModule } from '../../createModule';
import { parseInput } from '../../shared';
import * as TradesSchemas from './trades.schemas';
export const createTradesAPI = createModule(({ http }) => ({
    getTrades: async (params) => {
        const res = await http.get('/v2/trades/', {
            params,
        });
        return res;
    },
    getOlddbTrades: async (params) => {
        const res = await http.get('/v2/trades/olddb', {
            params,
        });
        return res;
    },
    getBespokeTrades: async (params) => {
        const res = await http.get('/v2/trades/bespoke', {
            params,
        });
        return res;
    },
    bookTrade: async (params) => {
        let body = parseInput(TradesSchemas.bookTradeSchema, params);
        const data = { ...body };
        data.price = data.price_format === 'percent' ? data.price / 100 : data.price;
        // Hotfix for tags being stored as string values in db
        // @ts-ignore
        data.tags = data.tags?.map((tag) => tag.trim().toLowerCase()).join(',') || null;
        const { strategy_type } = data;
        switch (strategy_type) {
            case 'FUND': {
                const { database, ...trade } = data;
                return http.post('/v2/trades/book/fund', {
                    body: { trade, database },
                });
            }
            case 'AMC': {
                const { database, ...trade } = data;
                return http.post('/v2/trades/book/amc', {
                    body: { trade, database },
                });
            }
            case 'BESPOKE': {
                return http.post('/v2/trades/book/bespoke', {
                    body: { trade: data },
                });
            }
        }
    },
    getInfoFromInstrumentAndStrategy: async ({ instrument_id, strategy_id }) => {
        const res = await http.get(`/v2/trades/instrument-data/${instrument_id}`, {
            params: {
                strategy_id,
            },
        });
        return res;
    },
    updateTrade: async (body) => {
        const params = parseInput(TradesSchemas.updateTradeSchema, body);
        const res = await http.patch(`/v2/trades/trade`, { body: params });
        return res;
    },
    updateBespokeTrade: async (body) => {
        const params = parseInput(TradesSchemas.updateBespokeTradeSchema, body);
        const res = await http.patch(`/v2/trades/trade/bespoke`, { body: params });
        return res;
    },
    updateOlddbTrade: async (body) => {
        const params = parseInput(TradesSchemas.updateTradeSchema, body);
        const res = await http.patch(`/v2/trades/trade/olddb`, { body: params });
        return res;
    },
    getTraders: async (params) => {
        const res = await http.get('/v2/static/traders', { params });
        return res;
    },
    getTradeTypes: async () => {
        const res = await http.get('/v2/static/trade-types');
        return res;
    },
    deleteOldDBTrade: async (body) => {
        const params = parseInput(TradesSchemas.deleteOldDBTradeSchema, body);
        const res = await http.post(`/v2/trades/delete/olddb/`, { body: params });
        return res;
    },
    sendBespokeEmail: async (body) => {
        const params = parseInput(TradesSchemas.sendBespokeInvoiceSchema, body);
        const res = await http.post('/v2/trades/bespoke/invoice', { body: params });
        return res;
    },
    checkUploadedTrades: async (body) => {
        const file = body.file.item(0);
        if (!file) {
            throw new Error('You must provide a file.');
        }
        const formData = new FormData();
        formData.append('file', file);
        return await http.post('/v2/trades/upload/check', { body: formData });
    },
    bookUploadedTrades: async (body) => {
        return await http.post('/v2/trades/upload/book', { body });
    },
    downloadTemplate: async () => {
        const res = await http.get('/v2/trades/download/template', {
            responseType: 'arraybuffer',
        });
        return res;
    },
}));
// const parseTradeBody = <T extends Trades.BookTradeBody>(trade: T): T => {
//   const _data = { ...trade }
//   _data.price = _data.price_format === 'percent' ? _data.price / 100 : _data.price
//   // Hotfix for tags being stored as string values in db
//   // @ts-ignore
//   _data.tags = _data.tags?.map((tag) => tag.trim().toLowerCase()).join(',') || null
//   return _data
// }
